import { render, staticRenderFns } from "./ExecutiveMembers.vue?vue&type=template&id=a96b8ba6"
import script from "./ExecutiveMembers.vue?vue&type=script&lang=js"
export * from "./ExecutiveMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports